<template>
  <el-dialog :visible.sync="visibleModal" width="760px" @open="onModalOpen" @close="onModalCancel">
    <span class="custom-modal-title" slot="title">
      <div class="title-text">
        <h4>批量联调/数据同步</h4>
        <span v-if="list.length" class="selected-num">已选择{{ list.length }}条计划</span>
      </div>
      <el-button v-if="enableImportAccounts" class="add-account-btn" @click="showAccountsInputModal" type="text">批量添加账号</el-button>
    </span>

    <el-form label-width="110px">
      <el-form-item label="同步数据时间">
        <DateRangePicker v-model="daterange" style="width: 240px"></DateRangePicker>
      </el-form-item>
      <el-form-item label="创建汇总计划" v-if="enableSummary">
        <div class="summary-switch">
          <el-switch v-model="isSummary"></el-switch>
          <el-tooltip effect="dark" content="Top Center 提示文字" placement="top">
            <div style="width: 320px" slot="content">
              <p>说明：</p>
              <p>1、开启该开关时，会根据设置在账号内创建一条计划；</p>
              <p>
                2、账号内的所有的消耗会同步汇总在【该条计划】里面；如果后续不想做汇总该计划，可以在【同步任务】-【编辑】里面转换【数据匹配模式】为【合并汇总到1条计划上】
              </p>
              <p>3、目前仅支持头条、腾讯、快手、百度</p>
            </div>
            <span class="el-icon-warning-outline"></span>
          </el-tooltip>
        </div>
      </el-form-item>
      <template v-if="isSummary">
        <el-form-item label="游戏选择">
          <el-select v-model="gameId" :popper-append-to-body="false" clearable collapse-tags filterable placeholder="全部">
            <el-option v-for="item in POPULAR_GAMES" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消耗归属">
          <p>该账号的所有计划消耗会合计同步到【该条新建的汇总计划上面】</p>
        </el-form-item>

        <el-form-item label="计划名称">
          <p>汇总计划-【账号名称】-【新建时间】</p>
        </el-form-item>
      </template>
    </el-form>

    <el-table v-loading="submitLoading" class="common-el-table-styles" height="320" :data="list" border ref="tableRef">
      <el-table-column label="序号">
        <template slot-scope="{ $index }">
          <div>{{ $index + 1 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="accountId" label="账号id" show-overflow-tooltip></el-table-column>
      <el-table-column prop="adAccount" label="账号名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="advertiserId" label="计划主id" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mediaName" label="媒体" show-overflow-tooltip></el-table-column>
      <el-table-column prop="opNames" label="管理人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="taskType" label="任务类型" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ $index, row }">
          <span v-if="syncFlag" class="sync-status">
            <span class="succ" v-if="row.msg === '成功'">{{ row.msg }}</span>
            <span class="error" v-else>{{ row.msg }}</span>
          </span>
          <el-button v-else type="text" @click="removeRow($index)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="syncFlag" type="primary" @click="onCloseModal">知道了</el-button>
      <template v-else>
        <el-button @click="onModalCancel">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSyncSubmit">确 定</el-button>
      </template>
    </span>
    <el-dialog width="550px" title="导入详情" :close-on-click-modal="false" :visible.sync="accountsImportResultModal" append-to-body>
      <p>导入成功{{ adAccountImportResult.successCount }}条，失败{{ adAccountImportResult.failCount }}条。</p>
      <el-table
        v-if="adAccountImportResult.failCount > 0"
        class="common-el-table-styles"
        height="180"
        :data="adAccountImportResult.list"
        border
      >
        <el-table-column prop="accountName" label="账号名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reason" label="失败原因" show-overflow-tooltip></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="accountsImportResultModal = false">知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog width="450px" title="批量添加账号" :close-on-click-modal="false" :visible.sync="accountsInputModal" append-to-body>
      <el-form ref="addAccountFormRef" label-width="90px" :rules="addAccountRules" :model="addAccountForm">
        <el-form-item label="媒体" prop="mediaId">
          <el-select
            v-model="addAccountForm.mediaId"
            style="width: 100%"
            :popper-append-to-body="false"
            clearable
            collapse-tags
            filterable
            placeholder="全部"
          >
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账号名称" prop="adAccounts">
          <el-input
            v-model="addAccountForm.adAccounts"
            type="textarea"
            rows="5"
            placeholder="每行一个账号名称（通过回车换行），只能导入自己有管理权限的账号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <p>已输入账号{{ adAccountNames.length }}/200</p>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="onAddAccountCancel">取 消</el-button>
        <el-button type="primary" :loading="addAccountSubmitLoading" @click="onAddAccountSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import moment from 'moment'
import { batchSyncData, taskSyncBatchAddAccounts } from '@/api/ptom.data.model'
import DateRangePicker from '@/components/date-range-picker'
import { initPageData, POPULAR_GAMES, MEDIAS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([POPULAR_GAMES, MEDIAS])

const validateAdAccounts = (rule, value, callback) => {
  if (value) {
    const accounts = value.split('\n').filter((item) => item.trim())
    if (accounts.length > 200) {
      callback(new Error('计划账号数量不能超过200个'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

const addAccountRules = {
  mediaId: [{ required: true, message: '媒体ID不能为空', trigger: 'change' }],
  adAccounts: [
    { required: true, message: '计划账号不能为空', trigger: 'blur', whitespace: true },
    { validator: validateAdAccounts, trigger: 'blur' }
  ]
}
export default {
  props: {
    visible: {
      type: Boolean
    },
    list: {
      type: Array,
      required: true
    },
    enableImportAccounts: {
      type: Boolean,
      default: false
    },
    enableSummary: {
      type: Boolean,
      default: false
    }
  },
  components: { DateRangePicker },
  data() {
    return {
      daterange: [],
      isSummary: false,
      gameId: '',
      submitLoading: false,
      syncFlag: false, // 是否显示同步结果
      accountsInputModal: false,
      accountsImportResultModal: false,
      addAccountSubmitLoading: false,
      addAccountRules,
      addAccountForm: {
        mediaId: '',
        adAccounts: ''
      },
      adAccountImportResult: {
        count: 0,
        list: []
      }
    }
  },

  computed: {
    ...PAGE_REQUIRED_OPTS,
    adAccountNames() {
      return this.addAccountForm.adAccounts
        .split('\n')
        .map((i) => i.trim())
        .filter((i) => !!i)
    },
    visibleModal: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  },
  methods: {
    onSyncSubmit() {
      // visibleModal = false
      const taskIds = this.list.map((item) => item.taskId)
      const [startDay, endDay] = this.daterange || []
      const params = { taskIds, startDay, endDay }
      if (this.isSummary && this.enableSummary) {
        params.gameId = this.gameId
        if (!this.gameId) {
          this.$Message.error('请选择游戏')
          return
        }
      }
      this.submitLoading = true

      batchSyncData(params)
        .then((data) => {
          if (Object.keys(data).length) {
            const newList = this.list.map((item) => ({ ...item, msg: data[item.taskId] }))
            this.$emit('update:list', newList)
            this.syncFlag = true
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    onModalOpen() {
      const [firstRow] = this.list
      // 同步任务管理的弹窗enableSummary 为true，用它来判断是同步任务管理或者是财务对账
      const daterange = this.enableSummary
        ? [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        : [moment(firstRow.tdate).format('YYYY-MM-01'), moment(firstRow.tdate).endOf('month').format('YYYY-MM-DD')]

      this.daterange = daterange
    },
    onCloseModal() {
      this.onModalCancel()
      this.$emit('refresh')
    },
    removeRow(index) {
      const newList = this.list.filter((_, i) => i !== index)
      this.$emit('update:list', newList)
    },
    onModalCancel() {
      this.visibleModal = false
      this.syncFlag = false
      this.isSummary = false
    },
    showAccountsInputModal() {
      this.accountsInputModal = true
    },
    onAddAccountSubmit() {
      this.$refs.addAccountFormRef.validate((valid) => {
        if (valid) {
          const { mediaId } = this.addAccountForm
          taskSyncBatchAddAccounts({ mediaId, accountNames: this.adAccountNames }).then((data) => {
            const { fail, success } = data || {}

            this.adAccountImportResult = {
              failCount: fail.length,
              successCount: success.length,
              list: fail
            }

            this.accountsImportResultModal = true
            this.onAddAccountCancel()

            if (success?.length) {
              const succList = success.map((acc) => ({ ...acc, taskType: ['', '爬虫', '接口'][acc.taskType] }))
              const existIds = this.list.map((i) => i.accountId)
              const newList = [...this.list]

              for (let i = 0; i < succList.length; i++) {
                const succAccount = succList[i]
                if (!existIds.includes(succAccount.accountId)) {
                  newList.push(succAccount)
                }
              }

              this.$emit('update:list', newList)
            }
          })
        }
      })
    },
    onAddAccountCancel() {
      this.accountsInputModal = false
      this.addAccountForm = {
        mediaId: '',
        adAccounts: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-modal-title {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .add-account-btn {
    margin-right: 30px;
    padding: 0;
  }

  .title-text {
    display: flex;
    align-items: center;
  }
  .selected-num {
    font-size: 13px;
    margin-left: 30px;
  }
}
.summary-switch {
  display: flex;
  line-height: 32px;
  height: 32px;
  align-items: center;

  span {
    cursor: pointer;
    margin-left: 5px;
  }
}
.sync-status {
  .succ {
    color: green;
  }
  .error {
    color: red;
  }
}
</style>
